<template>
    <div class="bg-white rounded h-screen shadow">
        <div>
            <ButtonTag class="mt-4 ml-4 mb-2" :do-action="addTaxModal" :is-w100="false" v-if="canManageProducts()">
                {{ $t('add') }}
            </ButtonTag>
        </div>

        <div class="container">
            <div class="row">
                <table class="w-full mt-3">
                    <thead class="bg-lightGray h-10">
                    <tr>
                        <th class="d-none d-md-table-cell pl-3 font-bold">#</th>
                        <th class="font-bold">{{ $t('name') }}</th>
                        <th class="d-none d-md-table-cell">{{ $t('sale.discount.percentAmount') }}</th>
                        <th>{{ $t('actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in getTaxes" :key="index" class="h-10" style="border-bottom: 1px solid #EFE8FC">
                        <td class="d-none d-md-table-cell pl-3">{{ index + 1 }}</td>
                        <td class="text-main font-bold">{{ item.name }}</td>
                        <td class="font-bold">{{ item.percent + ' ' }}%</td>
                        <td class="d-table-cell">
                            <span>
                                <img src="/images/edit.png" alt="" class="h-6 cursor-pointer" @click="$router.push($i18nHelper.getUrl('sales/taxes/edit/' + item.id))">
                                <img src="/images/Union.png" alt="" class="h-6 cursor-pointer pl-3" @click="$bvModal.show('delete-tax-' + item.id)">
                            </span>
                            <Modal
                                text="deleteConfirm"
                                ok-text="yes"
                                cancel-text="no"
                                :is-ok-only="false"
                                :context="{name: item.name}"
                                :id="'delete-tax-' + item.id"
                                :on-ok-pressed="() => {deleteOneTax(item.id)}"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div v-if="getTaxes.length === 0" class="col-12">{{ $t('noData') }}</div>
            </div>
        </div>

        <div class="row">
            <div class="col mt-4 ml-4">
                <Pagination
                    :search="search"
                    base-url="sales/taxes"
                    :total-items="getTaxesTotalCount"
                    method-name="fetchAllTaxes"
                />
            </div>
        </div>

        <b-modal class="modal fade" id="addTax" :title="$t('add')" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                <Row type="container">

                    <div class="grid grid-cols-1">
                        <div class="position-relative">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-4">
                                {{ $t('sale.tax.name') }}
                            </div>
                            <InputBox
                                class="w-full"
                                model-name="name"
                                :model-form="modelForm"
                            />
                        </div>

                        <div class="position-relative pl-0 mt-4">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-4">
                                {{ $t('sale.discount.percentAmount') }}
                            </div>
                            <InputBox
                                    class="w-full"
                                    :model-form="modelForm"
                                    model-name="percent"
                                    :no-margin-top="true"
                                    type="number"
                            />
                        </div>
                    </div>

                    <SubmitRow
                        class="mx-0 mt-4"
                        :is-disabled="checkForDisabling"
                        text="save"
                        sm-size="12"
                        md-size="12"
                        :do-action="addTax"
                        :is-loading="isLoading"
                    />
                </Row>
            </div>


        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import Pagination from "@/components/html/Pagination";
import dateFormatting from "@/mixin/dateFormattingMixin";
import ButtonTag from "@/components/html/ButtonTag";
import Row from "@/components/html/Row.vue";
import InputBox from "@/components/InputBox.vue";
import SubmitRow from "@/components/SubmitRow.vue";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "List",
    components: {
        Modal,
        SubmitRow,
        InputBox,
        Row,
        Pagination,
        ButtonTag
    },
    mixins: [dateFormatting, accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'sale.title', url: 'sales/sale'},
                {name: 'sale.tax.title', url: 'sales/taxes'}
            ],
            isLoading: false,
            search: {
                page: 1
            },
            modelForm: {
                percent: '',
                name: '',
                company: ''
            },
        }
    },
    computed: {
        ...mapGetters(['getTaxes', 'getTaxesTotalCount', 'getUserCompanyIdAt']),
        checkForDisabling() {
            return !(this.modelForm.name && this.modelForm.percent)
        },
    },
    methods: {
        ...mapActions(['fetchAllTaxes', 'setBreadcrumbItems', 'pushTax', 'putTax', 'fetchTax', 'deleteTax']),
        addTax() {
            this.$root.showOverlay = true
            this.isLoading = true
            this.modelForm.company = this.getUserCompanyIdAt

            if (this.$route.name === "sales/taxes/edit") {
                this.putTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.fetchAllTaxes()
                        this.$i18nHelper.toUrl('sales/taxes')
                        this.$bvModal.hide('addTax')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
            } else {
                this.pushTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.fetchAllTaxes()
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                        this.isLoading = false
                        this.$bvModal.hide('addTax')
                    })
            }
        },
        deleteOneTax(id) {
            this.$root.showOverlay = true
            this.deleteTax(id)
                .then(() => {
                    this.$root.showOverlay = false
                })
                .finally(() => {
                    this.fetchAllTaxes()
                })
        },
        addTaxModal() {
            this.$bvModal.show('addTax')
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>


</style>
